import { useResetAtom } from 'jotai/utils';

import { alertBannerAtom } from '../atoms';

export const useResetAlertBannerAtom = () => useResetAtom(alertBannerAtom);
